module.exports = __webpack_public_path__ + "img/userLogo21.96a2ded8.jpg";